import { useTranslation } from 'react-i18next';
import {
  ToggleButton,
  ToolbarIcon,
  TextEditorToolbarSection,
} from '../../styles';
import { useMarkdownEditor } from 'components/WYSIWYG/MarkdownEditor/context';
import { useGridLikeFlexChildProps } from 'components/StandaloneToolBar/components/GridLikeFlex';
import { useEffect, useState } from 'react';

export const TextStyleToolbarSection = () => {
  const { t } = useTranslation();
  const { editor, subscribeToSelectionUpdate, subscribeToUpdate } =
    useMarkdownEditor();
  const [ref, props] = useGridLikeFlexChildProps();
  const [
    {
      boldActive,
      italicActive,
      strikeActive,
      boldEnabled,
      italicEnabled,
      strikeEnabled,
    },
    setState,
  ] = useState(() => ({
    boldActive: editor?.isActive('bold'),
    italicActive: editor?.isActive('italic'),
    strikeActive: editor?.isActive('strike'),
    boldEnabled: editor?.can().toggleBold(),
    italicEnabled: editor?.can().toggleItalic(),
    strikeEnabled: editor?.can().toggleStrike(),
  }));

  useEffect(() => {
    const handler = ({ editor }) => {
      if (!editor) {
        return;
      }
      const isCodeBlocActive = editor.isActive('codeBlock');
      setState({
        boldActive: editor.isActive('bold'),
        italicActive: editor.isActive('italic'),
        strikeActive: editor.isActive('strike'),
        boldEnabled: !isCodeBlocActive && editor.can().toggleBold(),
        italicEnabled: !isCodeBlocActive && editor.can().toggleItalic(),
        strikeEnabled: !isCodeBlocActive && editor.can().toggleStrike(),
      });
    };

    const selectionUnsubscribe = subscribeToSelectionUpdate(
      'text-style-toolbar-section',
      handler
    );
    const updateUnsubscribe = subscribeToUpdate(
      'text-style-toolbar-section',
      handler
    );

    return () => {
      selectionUnsubscribe();
      updateUnsubscribe();
    };
  }, [subscribeToSelectionUpdate, subscribeToUpdate]);

  if (!editor) {
    return null;
  }
  return (
    <TextEditorToolbarSection ref={ref} {...props}>
      <ToggleButton
        active={boldActive}
        title={t('Bold')}
        onClick={() => editor.chain().focus().toggleBold().run()}
        disabled={!boldEnabled}
      >
        <ToolbarIcon icon="bold" color="var(--color-background-darker)" />
      </ToggleButton>
      <ToggleButton
        active={italicActive}
        title={t('Italic')}
        onClick={() => editor.chain().focus().toggleItalic().run()}
        disabled={!italicEnabled}
      >
        <ToolbarIcon icon="italic" color="var(--color-background-darker)" />
      </ToggleButton>
      <ToggleButton
        active={strikeActive}
        title={t('Strikethrough')}
        onClick={() => editor.chain().focus().toggleStrike().run()}
        disabled={!strikeEnabled}
      >
        <ToolbarIcon
          icon="strikethrough"
          color="var(--color-background-darker)"
        />
      </ToggleButton>
    </TextEditorToolbarSection>
  );
};
